export function createRouter(routes, { onResolve }) {
  const base = (import.meta.env.BASE_URL || '/').replace(/\/+$/, '') || ''

  function stripBase(pathname) {
    if (base && pathname.startsWith(base)) {
      return pathname.slice(base.length) || '/'
    }
    return pathname
  }

  function match(pathname) {
    const path = stripBase(pathname).replace(/\/+$/, '') || '/'
    for (const route of routes) {
      const keys = []
      const pattern = route.path
        .replace(/\/+$/, '')
        .replace(/:([A-Za-z_]+)/g, (_, k) => {
          keys.push(k)
          return '([^/]+)'
        })
      const re = new RegExp(`^${pattern === '' ? '/' : pattern}$`)
      const m = path.match(re) || (route.path === '/' && path === '/' ? ['/'] : null)
      if (!m) continue
      const params = {}
      keys.forEach((k, i) => {
        params[k] = decodeURIComponent(m[i + 1] || '')
      })
      return { route, params, path }
    }
    return { route: routes.find((r) => r.path === '/404') || routes[0], params: {}, path }
  }

  async function resolve() {
    const found = match(window.location.pathname)
    await onResolve(found)
  }

  function navigate(to, { replace = false } = {}) {
    let url = typeof to === 'string' ? to : to.pathname
    if (url.startsWith('/') && base && !url.startsWith(base)) {
      url = base + url
    }
    if (replace) window.history.replaceState({}, '', url)
    else window.history.pushState({}, '', url)
    return resolve()
  }

  document.addEventListener('click', (ev) => {
    const a = ev.target.closest('a[data-link]')
    if (!a) return
    const href = a.getAttribute('href')
    if (!href || href.startsWith('http') || href.startsWith('mailto:')) return
    ev.preventDefault()
    navigate(href)
  })

  window.addEventListener('popstate', () => {
    resolve()
  })

  return { navigate, resolve, match, base }
}
